import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Item } from 'components/Layout';

export const PendingChangeLine = ({ label, children }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;

  return (
    <Item
      flex
      style={{
        alignItems: 'baseline',
        justifyContent: 'flex-start',
        gap: '12px'
      }}
    >
      <Text
        component="span"
        fontSize="11.5px"
        style={{
          color: designSystem.inkSoft,
          whiteSpace: 'nowrap',
          width: '150px',
          flexShrink: 0
        }}
      >
        {label}
      </Text>
      {children}
    </Item>
  );
};

PendingChangeLine.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default PendingChangeLine;
